'use strict'; // Static Methods

require('./escape'); // Instance Methods


require('./addFlags');

require('./getFlags');

require('./removeFlags');

require('./setFlags');

module.exports = require('sugar-core');